(function () {
    'use strict';

    angular.module('swif.ui')
    .component('swifActions', {
        templateUrl: 'partials/ui/actions.html',
        controller: swifActionsController,
        bindings: {
            ngModel: '=',
            callback: '=',
            category: '@',
            mode: '@',
            preValidate: '=',
            preModal: '=',
            dismissCallback: '=',
            type: '@',
            tooltipPlacement: '@'
        }
    })
    .directive('swifCurrentLinkAction', swifCurrentLinkAction);


    function swifActionsController($scope, actionService) {
        'ngInject';
        var $ctrl = this;
        this.$onInit = function () {
            if ($ctrl.mode === undefined) {
                $ctrl.mode = 'buttons';
            }
            if ($ctrl.tooltipPlacement === undefined) {
                $ctrl.tooltipPlacement = 'top';
            }
            updateActions();
        };
        this.$onChanges = function() {
            updateActions();
        };
        function updateActions() {
            if (!$ctrl.type && !$ctrl.ngModel) {
                $ctrl.actions = [];
            } else {
                $ctrl.actions = actionService.getActions(
                    $ctrl.type || $ctrl.ngModel.contentType,
                    $ctrl.category,
                    $ctrl.ngModel
                );
            }
        }
        $scope.$watch('$ctrl.ngModel.actions', function (newV) {
            if (newV) {
                updateActions();
            }
        });
        $scope.$watch('$ctrl.ngModel.__updateActions', function (newV) {
            if (newV) {
                updateActions();
            }
        }, true);
        $ctrl.dispatchAction = function (action) {
            actionService.dispatch(
                $ctrl.type,
                action,
                $ctrl.ngModel,
                {
                    preModal: $ctrl.preModal,
                    preValidate: $ctrl.preValidate,
                    callback: $ctrl.callback,
                    dismissCallback: $ctrl.dismissCallback
                }
            );
        };
    }


    function swifCurrentLinkAction($location) {
        'ngInject';
        return {
            restrict: 'A',
            scope: {
                swifCurrentLinkAction: '=',
            },
            link: function (scope, element, attr, ngModel) {
                if (scope.swifCurrentLinkAction.link === $location.path()) {
                    if (element.get(0).tagName === 'BUTTON'){
                        element.addClass('btn-success active');
                        element.prop('disabled', true);
                        element.attr('disabled', 'disabled');
                    }
                }
            }
        };
    }

})();
